var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-8.3%",
    width: "116.7%",
    height: "116.7%",
    filterUnits: "objectBoundingBox",
    id: "edit_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#edit_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.095 14.036l4.978-4.99 1.277 1.28-4.984 4.98h-1.27v-1.27zm6.342-6.357L15.72 8.96l-.734.733-1.28-1.279.73-.736zM7.647 16.2h1.905a.45.45 0 00.316-.131l6.8-6.793a.446.446 0 000-.632l-1.915-1.913a.447.447 0 00-.633 0l-6.789 6.804a.457.457 0 00-.131.316v1.902c0 .247.2.447.448.447z",
    fill: "currentColor"
  }))));
};
export default SvgEdit;